export const DroughtMapConstants = {
    CommonLayers : [
      {
        layerNameType : 'STATE',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        pane : 'popup',
        styles:'ALL_INDIA_STATE_NAMES',
        maxZoom:7
      },
      {
        layerNameType : 'STATE',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Time',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        pane : 'popup'
      },
      {
        layerNameType : 'DISTRICT',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        pane : 'village',
        styles:'ALL_INDIA_DISTRICT_NAMES',
       minZoom:8,
        maxZoom:9
      },
      // {
      //   layerNameType : 'DISTRICT',
      //   serviceType : 'VectorLayer',
      //   view : 'Both',
      //   type : 'Time',
      //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
      //   dataurl : 'heatWatches/getHeatWatchesData' ,
      //   hval :"hwv",
      //   hcat : "hwc",
      //   pane : 'district'
      // },
      // {
      //   layerNameType : 'BLOCKS',
      //   serviceType : 'WmsLayer',
      //   view : 'Both',
      //   type : 'Base',
      //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
      //   pane : 'popup',
      //   styles:'ALL_INDIA_BLOCK_NAMES',
      //   minZoom:10
      // },
      {
        layerNameType : 'BLOCKS',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        // dataurl : 'heatWatches/getHeatWatchesData' ,
        // hval :"hwv",
        // hcat : "hwc",
        pane : 'block',
        minZoom : 5,
      },
      // {
      //   layerNameType : 'FORECAST_ADMIN_WITH_MASK',
      //   serviceType : 'WmsLayer',
      //   view : 'Admin',
      //   type : 'Base',
      //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
      // },
        // {
        //     layerName : 'forecast:ANDHRA PRADESH_STATE_DISTRICT',
        //     serviceType : 'WmsLayer',
        //     view : 'Admin',
        //     type : 'Base',
        //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        //     style : "forecast:district_bg"
        //   },
        //   {
        //     layerName : 'forecast:INDIA_BLOCK_FORECAST',
        //     serviceType : 'WmsLayer',
        //     view : 'Admin',
        //     type : 'Base',
        //     name : 'blockLayer',
        //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        //     minZoom : 9
        //   },
        //   {
        //     layerName : 'forecast:BASIN_INVERSE',
        //     serviceType : 'WmsLayer',
        //     view : 'Basin',
        //     type : 'Base',
        //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        //     hidelayer : true
        //   },
        //   {
        //     layerName : 'forecast:INDIA_FORECAST_BASIN_WITH_MASK',
        //     serviceType : 'WmsLayer',
        //     view : 'Basin',
        //     type : 'Base',
        //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
        //   },
        //   {
        //     layerName : 'forecast:INDIA_SUBBASIN',
        //     serviceType : 'WmsLayer',
        //     view : 'Basin',
        //     type : 'Base',
        //     name : 'blockLayer',
        //     env :'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        //     minZoom : 9
        //   },
          // {
          //   layerNameEnd : '_BLOCK',
          //   serviceType : 'VectorLayer',
          //   view : 'Admin',
          //   type : 'Base',
          //   locationName : 'block' ,
          //   minZoom:4
    
          // },
          // {
          //   layerNameEnd : '_BLOCK',
          //   serviceType : 'WmsLayer',
          //   view : 'Admin',
          //   type : 'Base',
          //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000', 
          //   style : 'forecast:block_only_label',
          //   minZoom:10
          // },
          // {
          //   layerNameEnd : '_SUBBASIN',
          //   serviceType : 'VectorLayer',
          //   view : 'Basin',
          //   type : 'Base',
          //   env :'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
          //   locationName : 'sub_basin' ,
          //   minZoom:9
          // }
    ],

    HeatMapOptions : {
      type : 'Time',
      view : 'Admin',
      serviceType : 'HeatMap'
    },

    CroppedHeatMapOptions : {
        type : 'Time',
        view : 'Admin',
        serviceType : 'CroppedHeatMap'
    },

    GeoJsonOptions : {
      type : 'Time',
      view : 'Admin',
      serviceType : 'GeoJsonMarker',
      pane : 'state'
    },
    DroughtControlLayers : [

        {
            "groupname" : "Mandatory Parameters",
            "show" : false,
            "subgroup" : [
                {
                    "name": "RF Deviation",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Mandatory",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" : "RF_DEVIATION"
                  },
                  {
                    "name": "Dry Spell",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Mandatory",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"WEEK_DRY_SPELL"
                  },
                   {
                    "name": "Trigger 1 Status",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Mandatory",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"MANDATORY_PARAMETER"
                  }
            ]
        },
      //   {
      //     "groupname" : "Reservoir Status",
      //     "show" : false,
      //     "subgroup" : [
      //         {
      //             "name": "Reservoir Storage Index",
      //             "visible": false,
      //             "layeroptions_show_on_selector": true,
      //             "type": "VECTOR",
      //             "group": "Mandatory",
      //             "custom" : true,
      //             "group_type" : "radio",
      //             "component_type" : "RF_DEVIATION"
      //           }
      //     ]
      // },
        {
            "groupname" : "Impact Parameters",
            "show" : false,
            "subgroup" : [
                {
                    "name": "Crop Sown Area",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Impact Parameters",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"SOWN_AREA"
                  },
                  {
                    "name": "Remote Sensing (VCI)",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Impact Parameters",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"SATELLITE_VCI"
                  },
                  {
                    "name": "Soil Moisture (PASM)",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Impact Parameters",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"PASM"
                  },
                   {
                    "name": "Trigger 2 Status",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Impact Parameters",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"IMPACT_PARAMETER"
                  }
            ]
        },
        {
            "groupname" : "Drought Status",
            "show" : false,
            "subgroup" : [
                {
                    "name": "Initial Recommendation",
                    "visible": false,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Drought Status",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"INITIAL_DROUGHT_RECOMMENDATION"
                  },
                   {
                    "name": "Final Recommendation",
                    "visible": true,
                    "layeroptions_show_on_selector": true,
                    "type": "VECTOR",
                    "group": "Drought Status",
                    "custom" : true,
                    "group_type" : "radio",
                    "component_type" :"FINAL_DROUGHT_RECOMMENDATION"
                  }
            ]
        }   
          
     ]



    
}